import { useEffect, useState } from 'react';
import { Text } from './Text';
import { formatTime } from '../../utils/formatters';

interface CountdownProps {
  targetMs: number;
  label: string;
  onComplete?: () => void;
}

export function Countdown({ targetMs, label, onComplete }: CountdownProps) {
  const [remaining, setRemaining] = useState<number>(() => Math.max(0, targetMs - Date.now()));

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemaining = Math.max(0, targetMs - Date.now());
      setRemaining(newRemaining);

      if (newRemaining === 0 && onComplete) {
        onComplete();
      }
    }, 100); // Update every 100ms for smooth countdown

    return () => clearInterval(interval);
  }, [targetMs, onComplete]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Text variant='body2'>
        {label}
        {formatTime(remaining)}
      </Text>
    </div>
  );
}
